
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.7875 9.90537L17.4049 14.1645L18.4399 20.18C18.4849 20.4431 18.3765 20.7089 18.1598 20.866C18.0374 20.9551 17.8918 21 17.7461 21C17.6343 21 17.5217 20.9733 17.419 20.9193L12 18.0792L6.58174 20.9186C6.34534 21.0435 6.05757 21.0231 5.84087 20.8653C5.62417 20.7082 5.51582 20.4424 5.56085 20.1793L6.59581 14.1638L2.21251 9.90537C2.02114 9.71879 1.95149 9.43962 2.03451 9.1864C2.11753 8.93318 2.33775 8.7473 2.603 8.70872L8.66011 7.83192L11.3689 2.35931C11.606 1.88023 12.394 1.88023 12.6311 2.35931L15.3399 7.83192L21.397 8.70872C21.6622 8.7473 21.8825 8.93248 21.9655 9.1864C22.0485 9.44032 21.9789 9.71809 21.7875 9.90537Z","fill":"#10001F"}})])
          )
        }
      }
    